'use client'

import { motion } from "framer-motion";
import g1 from "@/assets/gallery-1.jpg";
import g2 from "@/assets/gallery-2.jpg";
import g3 from "@/assets/gallery-3.jpg";
import g4 from "@/assets/gallery-4.jpg";
import g5 from "@/assets/gallery-5.jpg";
import g6 from "@/assets/gallery-6.jpg";
import Image from "next/image";

const items = [
  { src: g1, ratio: "aspect-[4/5]", label: "Platinum Balayage" },
  { src: g2, ratio: "aspect-square", label: "Soft Manicure" },
  { src: g3, ratio: "aspect-[3/4]", label: "Glow Facial" },
  { src: g4, ratio: "aspect-[3/4]", label: "Sculpted Bob" },
  { src: g5, ratio: "aspect-square", label: "Treatment Oil" },
  { src: g6, ratio: "aspect-[4/5]", label: "Spa Ritual" },
];

export function GallerySection() {
  return (
    <section id="gallery" className="mx-auto max-w-[1600px] px-6 py-20 md:px-12">
      <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="eyebrow">N° 03 — Portfolio</p>
          <h2 className="mt-4 max-w-2xl font-display text-5xl md:text-7xl">
            The result is <em>obvious</em>.
          </h2>
        </div>
      </div>

      <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [column-fill:_balance]">
        {items.map((item, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
            className="group mb-4 break-inside-avoid"
          >
            <div className={`relative overflow-hidden ${item.ratio}`}>
              <Image
                src={item.src}
                alt={item.label}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/70 to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <p className="text-[0.7rem] uppercase tracking-editorial text-nude">{item.label}</p>
              </div>
            </div>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
